
@switch (saveStatus) {
  @case ('saving') {
    <div class="saving">
      <span>Saving ...</span>
      <mat-progress-spinner color="primary" diameter="24" mode="indeterminate"></mat-progress-spinner>
    </div>
  }
  @case ('saved') {
    <div class="saved">
      <mat-icon>check</mat-icon>
      <span>Saved</span>
    </div>
  }
  @case ('failed') {
    <div class="failed">
      <mat-icon>error</mat-icon>
      <span>Failed to Save</span>
    </div>
  }
}
